import { Trans, useLingui } from '@lingui/react/macro';
import { Typography } from '@remarkable/ark-web';

import { NotificationBox } from 'src/components';

export const MissingPaymentDetailsNotification = () => {
  const { t } = useLingui();

  return (
    <NotificationBox
      title={t`Missing payment details`}
      data-cy="missing-payment-card-notification"
      variant="error"
    >
      <Typography variant="body-sm">
        <Trans>
          Please add your payment information for monthly or annual billing.
        </Trans>
      </Typography>
    </NotificationBox>
  );
};
